import { latestUpdates } from '@/mocks/homeData';

export default function LatestUpdate() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            最新更新
          </h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">
            每日精选最新上线的福利视频资源，保持收藏永不迷路
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latestUpdates.map((item) => (
            <a
              key={item.id}
              href={`/article/${item.id}`}
              className="group flex items-start gap-4 bg-background-100 rounded-xl p-5 hover:bg-accent-50 transition-all duration-300 cursor-pointer border border-transparent hover:border-accent-200"
            >
              <div className="shrink-0 w-2 h-2 mt-2 rounded-full bg-accent-400 group-hover:bg-accent-500 transition-colors"></div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-accent-600 transition-colors line-clamp-2 leading-snug mb-2">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-400">
                  <i className="ri-time-line mr-1"></i>{item.date}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}